import '../../assets/css/privacypolicy.css';

export default function PrivacyPolicy() {
    return (
        <main className="privacy">
            <div className="content-area page-wrapper" role="main">
                <div className="row row-main">
                    <div className="large-12 col">
                        <div className="col-inner">
                            <h1>Chính sách bảo mật</h1>
                            <p>
                                Navo Sổ Tiệm (“chúng tôi”) cam kết bảo vệ quyền riêng tư và dữ liệu cá nhân của bạn.
                                Chính sách bảo mật này giải thích cách chúng tôi thu thập, sử dụng, chia sẻ và bảo vệ
                                thông tin cá nhân khi bạn đăng ký, truy cập và sử dụng nền tảng cùng các dịch vụ của
                                chúng tôi (gọi chung là “Nền tảng”).
                            </p>

                            {/* 1 */}
                            <h2>1. Chúng tôi sẽ thu thập những thông tin cá nhân nào?</h2>

                            <h3>
                                1.1 Những thông tin cá nhân mà chúng tôi có thể thu thập bao gồm, nhưng không giới hạn
                                các thông tin sau:
                            </h3>
                            <ol className="pp-alpha">
                                <li>
                                    Thông tin tài khoản chủ tiệm khi đăng ký: số điện thoại, mật khẩu, tên cửa hàng, tên
                                    chủ cửa hàng và ngành nghề kinh doanh (salon, spa, nail, mắt kính, vật liệu, bán lẻ
                                    hoặc ngành khác);
                                </li>
                                <li>
                                    Thông tin nhân viên do chủ tiệm tạo và quản lý trên Nền tảng: họ tên, số điện thoại,
                                    mật khẩu đăng nhập, vai trò, quyền hạn, ngày tuyển dụng, mức lương cơ bản và phụ cấp;
                                </li>
                                <li>
                                    Thông tin khách hàng của tiệm do chủ tiệm/nhân viên nhập để phục vụ kinh doanh: tên,
                                    số điện thoại, loại khách hàng, điểm tích lũy, ghi chú sở thích và ghi chú nội bộ;
                                </li>
                                <li>
                                    Thông tin thanh toán: mã ngân hàng, tên ngân hàng, số tài khoản, tên chủ tài khoản và
                                    mã QR thanh toán do bạn cấu hình trên Nền tảng;
                                </li>
                                <li>
                                    Dữ liệu giao dịch và vận hành: đơn hàng, hóa đơn, sản phẩm/dịch vụ, tồn kho, lịch hẹn,
                                    ca làm, hoa hồng, lịch sử mua hàng và lịch sử tích/dùng điểm của khách;
                                </li>
                                <li>
                                    Thông tin liên hệ khi bạn để lại yêu cầu tư vấn qua biểu mẫu liên hệ: họ tên, email,
                                    số điện thoại, dịch vụ quan tâm và nội dung tin nhắn;
                                </li>
                                <li>
                                    Dữ liệu kỹ thuật phục vụ vận hành: phiên đăng nhập (mã thông báo/token), tùy chọn giao
                                    diện được lưu trên thiết bị của bạn, và các tập tin hình ảnh sản phẩm/dịch vụ bạn chủ
                                    động tải lên Nền tảng.
                                </li>
                            </ol>
                            <p>
                                Chúng tôi không chủ động thu thập dữ liệu vị trí (GPS), không thu thập danh bạ điện thoại,
                                và hiện không cung cấp tính năng hội thoại (chat) nội bộ trên Nền tảng.
                            </p>

                            <h3>
                                1.2 Trong quá trình bạn sử dụng Nền tảng và Dịch vụ, chúng tôi có thể thu thập thông tin
                                cá nhân của bạn trong các trường hợp sau:
                            </h3>
                            <ol className="pp-alpha">
                                <li>Khi bạn đăng ký và/hoặc mở một tài khoản với chúng tôi;</li>
                                <li>
                                    Khi bạn đăng ký và/hoặc sử dụng bất kỳ dịch vụ, tính năng nào có sẵn trên Nền tảng của
                                    chúng tôi;
                                </li>
                                <li>
                                    Khi bạn nhập, cập nhật dữ liệu khách hàng, nhân viên, sản phẩm/dịch vụ để vận hành cửa
                                    hàng;
                                </li>
                                <li>Khi bạn cấu hình thông tin thanh toán, tài khoản ngân hàng và mã QR;</li>
                                <li>Khi bạn tạo đơn hàng, hóa đơn và ghi nhận các giao dịch kinh doanh;</li>
                                <li>Khi bạn gửi yêu cầu tư vấn, liên hệ qua biểu mẫu trên Nền tảng;</li>
                                <li>
                                    Khi bạn đăng ký, tham gia bất kỳ khảo sát, chương trình khuyến mãi hoặc chiến dịch tiếp
                                    thị nào của chúng tôi;
                                </li>
                                <li>
                                    Khi bạn gửi khiếu nại, yêu cầu hỗ trợ, hoặc cung cấp thông tin cá nhân cho chúng tôi vì
                                    bất kỳ lý do gì.
                                </li>
                            </ol>

                            <h3>1.3 Tính chính xác của thông tin</h3>
                            <p>
                                Bạn đồng ý không cung cấp cho chúng tôi bất kỳ thông tin nào không chính xác hoặc gây hiểu
                                nhầm. Bạn cần thường xuyên cập nhật thông tin của mình và thông báo cho chúng tôi khi có
                                thay đổi. Chúng tôi có quyền yêu cầu bạn cung cấp tài liệu cần thiết để xác minh thông tin
                                do bạn cung cấp.
                            </p>

                            <h3>1.4 Đăng nhập qua mạng xã hội</h3>
                            <p>
                                Nền tảng hiện không cung cấp tính năng đăng nhập hoặc liên kết tài khoản qua mạng xã hội.
                                Các liên kết tới Zalo hoặc Facebook (nếu có) chỉ nhằm mục đích hỗ trợ, tư vấn khách hàng và
                                tuân theo chính sách của các nền tảng đó.
                            </p>

                            {/* 2 */}
                            <h2>2. Mục đích thu thập thông tin cá nhân</h2>
                            <p>
                                Chúng tôi có thể thu thập, sử dụng và/hoặc xử lý thông tin cá nhân của bạn vì một hoặc
                                nhiều mục đích sau đây:
                            </p>
                            <ul>
                                <li>Xác minh danh tính và quản lý tài khoản người dùng;</li>
                                <li>Cung cấp, vận hành và hỗ trợ các dịch vụ trên Nền tảng;</li>
                                <li>
                                    Giúp bạn quản lý cửa hàng: bán hàng, hóa đơn, tồn kho, khách hàng, nhân viên, lịch hẹn,
                                    hoa hồng, lương và thanh toán;
                                </li>
                                <li>Tạo mã QR và hỗ trợ đối soát thanh toán theo thông tin ngân hàng bạn cấu hình;</li>
                                <li>Phân quyền và kiểm soát truy cập giữa chủ tiệm, quản lý và nhân viên;</li>
                                <li>Phát hiện, ngăn chặn các hành vi gian lận và bảo đảm an toàn cho Nền tảng;</li>
                                <li>
                                    Gửi các thông báo vận hành, hỗ trợ hoặc tiếp thị mà chúng tôi cho là cần thiết, trừ khi
                                    bạn từ chối nhận;
                                </li>
                                <li>Phân tích, đánh giá nhằm cải thiện và nâng cấp chất lượng dịch vụ;</li>
                                <li>Và bất kỳ mục đích nào khác mà chúng tôi thông báo cho bạn tại thời điểm thu thập.</li>
                            </ul>

                            {/* 3 */}
                            <h2>3. Các trường hợp chia sẻ thông tin cá nhân</h2>
                            <p>
                                Chúng tôi không bán thông tin cá nhân của bạn. Chúng tôi chỉ chia sẻ thông tin trong phạm
                                vi cần thiết cho các bên thứ ba phục vụ việc cung cấp dịch vụ, và các bên này chỉ được sử
                                dụng dữ liệu theo sự cho phép của chúng tôi. Các bên thứ ba có thể bao gồm:
                            </p>
                            <ul>
                                <li>
                                    Nhà cung cấp dịch vụ gửi email (ví dụ EmailJS) để xử lý và phản hồi các yêu cầu liên hệ,
                                    tư vấn của bạn;
                                </li>
                                <li>
                                    Nhà cung cấp dịch vụ tạo mã QR thanh toán (ví dụ VietQR) dựa trên thông tin tài khoản
                                    ngân hàng bạn cung cấp;
                                </li>
                                <li>
                                    Nhà cung cấp hạ tầng, lưu trữ máy chủ và các dịch vụ kỹ thuật phục vụ vận hành Nền tảng;
                                </li>
                                <li>Đối tác hỗ trợ gửi thông báo (SMS, email) và hoạt động chăm sóc, tiếp thị (nếu có);</li>
                                <li>Các chi nhánh, công ty liên kết của chúng tôi;</li>
                                <li>
                                    Cơ quan nhà nước có thẩm quyền khi được yêu cầu hợp pháp, hoặc khi cần thiết để bảo vệ
                                    an toàn, an ninh cho Nền tảng và người dùng.
                                </li>
                            </ul>

                            {/* 4 */}
                            <h2>4. Cookies và lưu trữ trên thiết bị</h2>
                            <p>
                                Chúng tôi sử dụng cookies cùng các cơ chế lưu trữ cục bộ trên trình duyệt/thiết bị của bạn
                                (như localStorage) để duy trì phiên đăng nhập, ghi nhớ tùy chọn giao diện và giúp bạn không
                                phải nhập lại thông tin cho mỗi lần truy cập, qua đó cải thiện trải nghiệm sử dụng.
                            </p>
                            <p>
                                Khi truy cập và sử dụng Nền tảng, bạn đồng ý cho chúng tôi lưu trữ các thông tin này trên
                                thiết bị của bạn. Bạn có thể quản lý hoặc xóa cookies và dữ liệu lưu trữ thông qua cài đặt
                                trình duyệt/thiết bị; tuy nhiên, khi thực hiện điều này bạn có thể không sử dụng được đầy đủ
                                các chức năng của Nền tảng.
                            </p>

                            {/* 5 */}
                            <h2>5. Truy cập, điều chỉnh thông tin cá nhân</h2>
                            <ul>
                                <li>Bạn có thể xem và chỉnh sửa thông tin tài khoản tại trang Hồ sơ/Cài đặt của mình;</li>
                                <li>
                                    Bạn có thể yêu cầu truy cập các thông tin khác mà chúng tôi thu thập từ bạn bằng cách
                                    liên hệ qua email được công bố ở mục Liên hệ;
                                </li>
                                <li>
                                    Bạn có thể yêu cầu chấm dứt việc sử dụng thông tin cá nhân của mình bằng cách liên hệ
                                    với chúng tôi.
                                </li>
                            </ul>
                            <p>Chúng tôi có thể từ chối yêu cầu truy cập thông tin cá nhân nếu:</p>
                            <ul>
                                <li>Thông tin chỉ dùng cho mục đích phân tích và đánh giá nội bộ;</li>
                                <li>Thông tin được sử dụng cho mục đích giải quyết tranh chấp;</li>
                                <li>Thông tin gây tổn hại đến hoạt động thương mại và cạnh tranh của chúng tôi;</li>
                                <li>
                                    Chi phí, công sức cho việc cung cấp dữ liệu không tương xứng với lợi ích nhận được của
                                    chúng tôi hoặc của bạn.
                                </li>
                            </ul>
                            <p>Chúng tôi có quyền xác định thông tin nào nằm trong phạm vi có thể từ chối.</p>

                            {/* 6 */}
                            <h2>6. Các phương thức bảo vệ thông tin cá nhân</h2>
                            <p>Chúng tôi đảm bảo thông tin thu thập được lưu giữ an toàn bằng các phương thức sau:</p>
                            <ul>
                                <li>Giới hạn truy cập thông tin thông qua việc đăng nhập tài khoản;</li>
                                <li>
                                    Phân quyền chi tiết giữa chủ tiệm, quản lý và nhân viên để kiểm soát phạm vi truy cập dữ
                                    liệu;
                                </li>
                                <li>
                                    Xác thực phiên làm việc bằng mã thông báo (token) và cơ chế làm mới phiên có thời hạn;
                                </li>
                                <li>Truyền dữ liệu qua kết nối an toàn và áp dụng các biện pháp kỹ thuật phù hợp;</li>
                                <li>Xóa thông tin cá nhân khi không còn cần thiết cho mục đích lưu trữ hồ sơ.</li>
                            </ul>

                            {/* 7 */}
                            <h2>7. Lưu giữ thông tin cá nhân</h2>
                            <p>
                                Chúng tôi chỉ lưu giữ thông tin cá nhân của bạn trong thời gian do pháp luật yêu cầu, hoặc
                                cho đến khi mục đích thu thập thông tin đó không còn theo Chính sách này.
                            </p>

                            {/* 8 */}
                            <h2>8. Thay đổi Chính sách bảo mật</h2>
                            <p>
                                Chúng tôi có quyền thay đổi, cập nhật Chính sách bảo mật này bất kỳ lúc nào. Mọi thay đổi sẽ
                                được thông báo trên Nền tảng của chúng tôi.
                            </p>

                            {/* 9 */}
                            <h2>9. Rút lại sự đồng ý thu thập, sử dụng dữ liệu cá nhân</h2>
                            <p>
                                Bạn có thể rút lại sự đồng ý cho phép thu thập, sử dụng và/hoặc tiết lộ dữ liệu cá nhân mà
                                chúng tôi đang lưu giữ bằng cách gửi email theo thông tin bên dưới. Xin lưu ý rằng việc rút
                                lại sự đồng ý có thể đồng nghĩa với việc chúng tôi không thể tiếp tục cung cấp dịch vụ cho
                                bạn và có thể cần chấm dứt quan hệ hiện tại của bạn với chúng tôi.
                            </p>

                            {/* 10 */}
                            <h2>10. Thông tin liên hệ</h2>
                            <p>
                                Nếu bạn có bất kỳ câu hỏi nào về Chính sách bảo mật này, vui lòng liên hệ với chúng tôi:
                                <br />
                                Email: navosotiem@gmail.com
                                <br />
                                Hotline: 0886.299.670
                                <br />
                                Địa chỉ: HD Mon City, Nguyễn Cơ Thạch, Mỹ Đình 2, Hà Nội
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
